import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { authApi } from "../lib/api";
import { revokeNativePush } from "../lib/nativePush";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  // null = checking, false = anonymous, object = authenticated
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const data = await authApi.me();
      // Backend returns { user: null } for anonymous callers (no more 401 noise).
      const u = data.user || false;
      setUser(u);
      return u;
    } catch {
      setUser(false);
      return false;
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const data = await authApi.login(email, password);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const data = await authApi.register(payload);
    setUser(data.user);
    return data;
  };

  const logout = async () => {
    try {
      await revokeNativePush("customer").catch(() => {});
      await authApi.logout();
    } finally {
      setUser(false);
    }
  };

  return (
    <AuthContext.Provider value={{ user, setUser, refresh, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
